var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        { attrs: { dense: "" } },
        [
          _c(
            "v-col",
            [
              _c("MediaFilePickerForm", {
                attrs: {
                  count: _vm.value.length,
                  "file-type": _vm.filters.type,
                  "file-type-disabled":
                    _vm.fileType.value !== _vm.$options.mediaTypesKeys.ALL,
                  filters: _vm.filters,
                },
                on: {
                  "change-filters": _vm.updateFilters,
                  sort: function ($event) {
                    return _vm.sortFiles(_vm.value)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { dense: "" } },
        [
          _c(
            "v-col",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    [
                      _c(
                        "v-row",
                        [
                          _vm.$apollo.queries.files.loading
                            ? _c("v-progress-linear", {
                                attrs: { indeterminate: "", color: "primary" },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                _vm._l(_vm.files, function (file) {
                  return _c("MediaFilePreview", {
                    key: file.id,
                    attrs: {
                      "picker-mode": "",
                      description: "",
                      value: file,
                      "is-chosen": _vm.value.includes(file.id),
                    },
                    on: { change: _vm.updateFiles },
                  })
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            [
              _vm.paginationLength > 1
                ? _c("v-pagination", {
                    attrs: { dense: "", length: _vm.paginationLength },
                    model: {
                      value: _vm.page,
                      callback: function ($$v) {
                        _vm.page = $$v
                      },
                      expression: "page",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }